"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dcSummaryFormToPayloadDataHandler = dcSummaryFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function dcSummaryFormToPayloadDataHandler(data, _, selectedRole) {
    const now = (0, dayjs_1.default)();
    return {
        form: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ visitDate: data.visitDate, nameOfPersonSpokenTo: data.nameOfPersonSpokenTo }, (data.withVisit !== undefined && {
            withVisit: data.withVisit,
        })), (data.informedPhysician && {
            informedPhysician: data.informedPhysician,
        })), (data.notes && {
            comments: data.notes,
        })), (selectedRole && {
            discipline: selectedRole,
        })), { offSet: now.utcOffset() }),
    };
}
